import { FC, useCallback } from 'react'
import { PostUid } from 'interfaces/feed'
import { sendEventActionCreator } from 'components/features/beacon/actions'
import { useStoreDispatch } from 'helpers/reactReduxHelpers'
import Shownable from 'components/utils/Shownable'

type FeedPostImpressionHandlerProps = {
  postUid: PostUid
}
export const FeedPostImpressionHandler: FC<FeedPostImpressionHandlerProps> = (props) => {
  const { children, postUid } = props

  const dispatch = useStoreDispatch()

  const handleShown = useCallback(() => {
    dispatch(sendEventActionCreator('post_impression_category', { uid: postUid }))
  }, [dispatch, postUid])

  return (
    <Shownable onShown={ handleShown }>
      <div>
        { children }
      </div>
    </Shownable>
  )
}
